'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var React = require('react');
var client$1 = require('@apollo/client');
var error = require('@apollo/client/link/error');
var context = require('@apollo/client/link/context');
var reactTransitionGroup = require('react-transition-group');
var ReactMarkdown = require('react-markdown');
var rehypeRaw = require('rehype-raw');
var twemoji = require('twemoji');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var ReactMarkdown__default = /*#__PURE__*/_interopDefaultLegacy(ReactMarkdown);
var rehypeRaw__default = /*#__PURE__*/_interopDefaultLegacy(rehypeRaw);
var twemoji__default = /*#__PURE__*/_interopDefaultLegacy(twemoji);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __spreadArray(to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
  return to;
}
function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
}
var apolloClient;
var client = function (options) {
  if (apolloClient) {
    return apolloClient;
  }
  var apiUrl = options.apiUrl,
    apiKey = options.apiKey,
    getTokenCallback = options.getTokenCallback,
    getGuestTokenCallback = options.getGuestTokenCallback,
    onErrorCallback = options.onErrorCallback;
  var authLink = context.setContext(function (_, _a) {
    var headers = _a.headers;
    var apolloHeaders = {
      'x-api-key': apiKey,
      source: 'website'
    };
    if (getTokenCallback()) {
      apolloHeaders.authorization = getTokenCallback();
    } else if (getGuestTokenCallback()) {
      apolloHeaders['x-guest-token'] = getGuestTokenCallback();
    }
    return {
      headers: __assign(__assign({}, headers), apolloHeaders)
    };
  });
  var httpLink = new client$1.HttpLink({
    uri: apiUrl
  });
  var errorLink = error.onError(function (_a) {
    var networkError = _a.networkError,
      graphQLErrors = _a.graphQLErrors;
    if (graphQLErrors) {
      graphQLErrors.forEach(function (error) {
        var message = error.message,
          locations = error.locations,
          path = error.path;
        console.log("[GraphQL error]: Message: " + message + ", Location: " + locations + ", Path: " + path);
        onErrorCallback(error);
      });
    }
    if (networkError) {
      console.warn('networkError', networkError);
    }
  });
  apolloClient = new client$1.ApolloClient({
    cache: new client$1.InMemoryCache(),
    link: client$1.from([authLink, errorLink, httpLink])
  });
  return apolloClient;
};
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z$7 = ".button-module_button__1Tg9s {\n  position: relative;\n  padding: 10px;\n  margin-bottom: 10px;\n  background-color: white;\n  border: 1px solid #333333;\n  border-radius: 0;\n  font-family: \"sofia-pro\", sans-serif;\n  font-size: 18px;\n  line-height: 25px;\n  color: #333333;\n  text-align: center;\n  box-shadow: 0;\n  outline: none;\n  cursor: pointer;\n  transition: 0.2s all cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap; }\n  @media screen and (min-width: 1201px) {\n    .button-module_button__1Tg9s {\n      padding: 20px 10px; } }\n  @media screen and (min-width: 1201px) {\n    .button-module_button__1Tg9s:hover, .button-module_button__1Tg9s:focus {\n      box-shadow: 0 0.4px 0.4px rgba(0, 0, 0, 0.022), 0 1px 1px rgba(0, 0, 0, 0.031), 0 2.1px 2.1px rgba(0, 0, 0, 0.039), 0 4.4px 4.4px rgba(0, 0, 0, 0.048), 0 12px 12px rgba(0, 0, 0, 0.07); } }\n  .button-module_button__1Tg9s:disabled {\n    opacity: 0.5;\n    border-color: #d7d4c5;\n    cursor: not-allowed; }\n    .button-module_button__1Tg9s:disabled:hover, .button-module_button__1Tg9s:disabled:focus {\n      box-shadow: none; }\n  @media screen and (min-width: 768px) {\n    .button-module_button__1Tg9s {\n      flex-direction: column;\n      flex: 1 1 0;\n      max-width: 200px;\n      margin-bottom: 20px;\n      margin-left: 10px;\n      margin-right: 10px; } }\n  .button-module_button__1Tg9s img {\n    position: absolute;\n    left: 20px;\n    width: 1em;\n    height: 1em; }\n    @media screen and (min-width: 768px) {\n      .button-module_button__1Tg9s img {\n        position: relative;\n        left: auto;\n        margin-bottom: 10px;\n        width: 1.5em;\n        height: 1.5em; } }\n  .button-module_button__1Tg9s span {\n    display: block; }\n    .button-module_button__1Tg9s span + span {\n      margin-top: 4px;\n      margin-left: 10px;\n      font-size: 14px;\n      color: #79776b; }\n      @media screen and (max-width: 767px) {\n        .button-module_button__1Tg9s span + span {\n          flex-basis: 100%; } }\n      @media screen and (min-width: 768px) {\n        .button-module_button__1Tg9s span + span {\n          margin-top: 0;\n          margin-left: 0; } }\n\n.button-module_button-active__3iSZ9 {\n  background-color: #ffd326;\n  border-color: #ffd326; }\n\n.button-module_button__1Tg9s { }\n\n.button-module_buttonActive__21TAG { }\n\n.button-module_buttonContinueWrapper__133gP {\n  position: relative;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  flex: 0 0 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: center; }\n  @media screen and (max-width: 768px) {\n    .button-module_buttonContinueWrapper__133gP button {\n      max-height: 47px; } }\n  .button-module_buttonContinueWrapper__133gP .button-module_button__1Tg9s {\n    margin-bottom: 0;\n    font-weight: 800;\n    flex: 0 0 calc(50% - 20px); }\n    @media screen and (min-width: 768px) {\n      .button-module_buttonContinueWrapper__133gP .button-module_button__1Tg9s {\n        flex: 0 0 calc(33.333% - 20px); } }\n";
var styles$4 = {
  "button": "button-module_button__1Tg9s button-module_button__1Tg9s",
  "button-active": "button-module_button-active__3iSZ9 button-module_button__1Tg9s",
  "buttonActive": "button-module_buttonActive__21TAG button-module_button-active__3iSZ9 button-module_button__1Tg9s",
  "buttonContinueWrapper": "button-module_buttonContinueWrapper__133gP"
};
styleInject(css_248z$7);
function Button(_a) {
  var data = _a.data,
    selectedValues = _a.selectedValues,
    handleClick = _a.handleClick;
  var isSelected = selectedValues.find(function (selectedValue) {
    return selectedValue === data.id;
  });
  var isContinueButton = data.type === 'continue';
  return React__default['default'].createElement(React__default['default'].Fragment, null, isContinueButton ? React__default['default'].createElement("div", {
    className: styles$4.buttonContinueWrapper
  }, React__default['default'].createElement("button", {
    type: "button",
    className: styles$4.button,
    dangerouslySetInnerHTML: {
      __html: data.label
    },
    disabled: selectedValues.length === 0,
    onClick: function () {
      return handleClick({
        type: data.type,
        action: data.action,
        id: data.id
      });
    }
  })) : React__default['default'].createElement("button", {
    type: "button",
    className: isSelected ? styles$4.buttonActive : styles$4.button,
    dangerouslySetInnerHTML: {
      __html: data.image + data.label
    },
    onClick: function () {
      return handleClick({
        type: data.type,
        action: data.action,
        id: data.id
      });
    }
  }));
}
var css_248z$6 = ".input-module_button__1xmU6 {\n  position: relative;\n  padding: 10px;\n  margin-bottom: 10px;\n  background-color: white;\n  border: 1px solid #333333;\n  border-radius: 0;\n  font-family: \"sofia-pro\", sans-serif;\n  font-size: 18px;\n  line-height: 25px;\n  color: #333333;\n  text-align: center;\n  box-shadow: 0;\n  outline: none;\n  cursor: pointer;\n  transition: 0.2s all cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap; }\n  @media screen and (min-width: 1201px) {\n    .input-module_button__1xmU6 {\n      padding: 20px 10px; } }\n  @media screen and (min-width: 1201px) {\n    .input-module_button__1xmU6:hover, .input-module_button__1xmU6:focus {\n      box-shadow: 0 0.4px 0.4px rgba(0, 0, 0, 0.022), 0 1px 1px rgba(0, 0, 0, 0.031), 0 2.1px 2.1px rgba(0, 0, 0, 0.039), 0 4.4px 4.4px rgba(0, 0, 0, 0.048), 0 12px 12px rgba(0, 0, 0, 0.07); } }\n  .input-module_button__1xmU6:disabled {\n    opacity: 0.5;\n    border-color: #d7d4c5;\n    cursor: not-allowed; }\n    .input-module_button__1xmU6:disabled:hover, .input-module_button__1xmU6:disabled:focus {\n      box-shadow: none; }\n  @media screen and (min-width: 768px) {\n    .input-module_button__1xmU6 {\n      flex-direction: column;\n      flex: 1 1 0;\n      max-width: 200px;\n      margin-bottom: 20px;\n      margin-left: 10px;\n      margin-right: 10px; } }\n  .input-module_button__1xmU6 img {\n    position: absolute;\n    left: 20px;\n    width: 1em;\n    height: 1em; }\n    @media screen and (min-width: 768px) {\n      .input-module_button__1xmU6 img {\n        position: relative;\n        left: auto;\n        margin-bottom: 10px;\n        width: 1.5em;\n        height: 1.5em; } }\n  .input-module_button__1xmU6 span {\n    display: block; }\n    .input-module_button__1xmU6 span + span {\n      margin-top: 4px;\n      margin-left: 10px;\n      font-size: 14px;\n      color: #79776b; }\n      @media screen and (max-width: 767px) {\n        .input-module_button__1xmU6 span + span {\n          flex-basis: 100%; } }\n      @media screen and (min-width: 768px) {\n        .input-module_button__1xmU6 span + span {\n          margin-top: 0;\n          margin-left: 0; } }\n\n.input-module_button-active__28dVs {\n  background-color: #ffd326;\n  border-color: #ffd326; }\n\n.input-module_content__w6nDh {\n  display: flex;\n  flex-direction: column;\n  align-items: center; }\n\n.input-module_inputWrapper__276ZZ {\n  position: relative;\n  display: flex;\n  align-items: center; }\n  @media screen and (min-width: 768px) {\n    .input-module_inputWrapper__276ZZ {\n      margin-left: 10px;\n      margin-right: 10px; } }\n\n.input-module_input__Vdyh6 {\n  width: 100%;\n  padding: 30px 60px 10px 20px;\n  background-color: white;\n  border: 1px solid #d7d4c5;\n  border: none;\n  border-radius: 0;\n  font-family: inherit;\n  font-size: 18px;\n  color: #333333;\n  transition: 0.2s all cubic-bezier(0.25, 0.46, 0.45, 0.94); }\n  .input-module_input__Vdyh6:hover, .input-module_input__Vdyh6:focus {\n    outline: none;\n    border-color: #ffd326;\n    box-shadow: 0 0.4px 0.4px rgba(0, 0, 0, 0.022), 0 1px 1px rgba(0, 0, 0, 0.031), 0 2.1px 2.1px rgba(0, 0, 0, 0.039), 0 4.4px 4.4px rgba(0, 0, 0, 0.048), 0 12px 12px rgba(0, 0, 0, 0.07); }\n  @media screen and (min-width: 768px) {\n    .input-module_input__Vdyh6 {\n      width: 360px; } }\n\n.input-module_label__3f34V {\n  position: absolute;\n  left: 20px;\n  color: #adaa9b;\n  pointer-events: none;\n  transition: 0.2s all cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  transform-origin: top left; }\n\n.input-module_input__Vdyh6:focus + .input-module_label__3f34V,\n.input-module_inputHasValue__3fw66 + .input-module_label__3f34V {\n  transform: translateY(-10px) scale(0.777); }\n\n.input-module_hasError__3CdV9,\n.input-module_hasError__3CdV9:focus {\n  border-color: red; }\n\n.input-module_inputButton__3eL-L {\n  position: absolute;\n  right: 0;\n  height: 100%;\n  padding: 0 20px 0 10px;\n  background: none;\n  border: none;\n  opacity: 0.666;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n  @media screen and (min-width: 768px) {\n    .input-module_inputButton__3eL-L {\n      display: none; } }\n  .input-module_inputButton__3eL-L:focus {\n    outline: none; }\n  .input-module_inputButton__3eL-L:before {\n    content: '';\n    width: 30px;\n    height: 30px;\n    border: 2px solid #adaa9b;\n    border-radius: 30px;\n    opacity: 1;\n    transition: 0.2s all cubic-bezier(0.25, 0.46, 0.45, 0.94); }\n  .input-module_inputButton__3eL-L:after {\n    content: '';\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    border-top: 2px solid #adaa9b;\n    border-right: 2px solid #adaa9b;\n    transform: translateX(-2px) rotateZ(45deg);\n    transform-origin: center center;\n    transition: 0.2s all cubic-bezier(0.25, 0.46, 0.45, 0.94); }\n  .input-module_inputButton__3eL-L:disabled:before {\n    opacity: 0; }\n  .input-module_inputButton__3eL-L:disabled:hover:after {\n    border-color: #adaa9b; }\n  .input-module_inputButton__3eL-L:focus, .input-module_inputButton__3eL-L:hover {\n    opacity: 1; }\n    .input-module_inputButton__3eL-L:focus:before, .input-module_inputButton__3eL-L:focus:after, .input-module_inputButton__3eL-L:hover:before, .input-module_inputButton__3eL-L:hover:after {\n      border-color: #ffd326; }\n\n.input-module_button__1xmU6 {\n  min-width: 200px;\n  margin-top: 20px; }\n  @media screen and (max-width: 767px) {\n    .input-module_button__1xmU6 {\n      display: none; } }\n\n.input-module_buttonActive__pyPNL { }\n";
var styles$3 = {
  "button": "input-module_button__1xmU6 input-module_button__1xmU6",
  "button-active": "input-module_button-active__28dVs input-module_button__1xmU6",
  "content": "input-module_content__w6nDh",
  "inputWrapper": "input-module_inputWrapper__276ZZ",
  "input": "input-module_input__Vdyh6",
  "label": "input-module_label__3f34V",
  "inputHasValue": "input-module_inputHasValue__3fw66",
  "hasError": "input-module_hasError__3CdV9",
  "inputButton": "input-module_inputButton__3eL-L",
  "buttonActive": "input-module_buttonActive__pyPNL input-module_button-active__28dVs input-module_button__1xmU6"
};
styleInject(css_248z$6);
var CHAT_VARIANT = 'integrated';
// dev
// export const API_URL = 'https://imtbg2leizgi5hit4bmlfs6fju.appsync-api.eu-west-2.amazonaws.com/graphql';
// export const API_KEY = 'da2-feuhywv34bchnkru2hopbzihgi';
// prod
// export const API_URL = 'https://uoa5o5xsereeragtib2hkjbktu.appsync-api.ap-southeast-2.amazonaws.com/graphql';
// export const API_KEY = 'da2-tuufjmnngndzbbvdvoewwq2yfi';
// needs to match transition duration in slideLeft and slideRight css modules
var SLIDE_ANIMATION_DURATION = typeof window !== 'undefined' && window && window.innerWidth < 768 ? 250 : 500;
function Input(props) {
  var _a = React.useState(''),
    value = _a[0],
    setValue = _a[1];
  var _b = React.useState(true),
    isValid = _b[0],
    setIsValid = _b[1];
  var _c = React.useState(false),
    isSubmitted = _c[0],
    setIsSubmitted = _c[1];
  var inputElem = React.useRef(null);
  var type = props.type,
    data = props.data;
  var handleChange = function (e) {
    setValue(e.target.value);
    if (props.pattern) {
      setIsValid(props.pattern.test(e.target.value));
    } else {
      setIsValid(true);
    }
  };
  var handleSubmit = function () {
    var trimmedValue = value.trim();
    var valid = true;
    if (trimmedValue !== '') {
      if (props.pattern) {
        valid = props.pattern.test(trimmedValue);
      }
    } else {
      valid = false;
    }
    setIsValid(valid);
    if (valid) {
      setIsSubmitted(true);
      props.handleClick({
        type: data.type,
        action: data.action,
        id: data.id,
        value: trimmedValue
      });
    }
  };
  var handleEnterKey = function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (value && isValid) {
        handleSubmit();
      }
    }
  };
  React.useLayoutEffect(function () {
    setTimeout(function () {
      if (inputElem.current !== null) {
        inputElem.current.focus();
      }
    }, SLIDE_ANIMATION_DURATION);
  });
  return React__default['default'].createElement("div", {
    className: styles$3.content
  }, React__default['default'].createElement("div", {
    className: styles$3.inputWrapper
  }, React__default['default'].createElement("input", {
    ref: inputElem,
    className: styles$3.input + " " + (value ? styles$3.inputHasValue : '') + " " + (!isValid ? styles$3.hasError : ''),
    id: type,
    type: type,
    autoComplete: "off",
    onChange: handleChange,
    onKeyPress: handleEnterKey
  }), React__default['default'].createElement("label", {
    className: styles$3.label,
    htmlFor: type,
    dangerouslySetInnerHTML: {
      __html: data.label
    }
  }), React__default['default'].createElement("button", {
    type: "button",
    className: styles$3.inputButton,
    disabled: !value || !isValid,
    onClick: handleSubmit
  })), React__default['default'].createElement("button", {
    type: "button",
    className: isSubmitted ? styles$3.buttonActive : styles$3.button,
    disabled: !value || !isValid,
    onClick: handleSubmit
  }, "Continue"));
}
var css_248z$5 = ".slide-module_container__3F2DY {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center; }\n  @media screen and (min-width: 768px) {\n    .slide-module_container__3F2DY {\n      height: auto;\n      max-height: 100%;\n      padding-bottom: 40px;\n      justify-content: center; } }\n\n.slide-module_question__1amzQ {\n  max-width: 360px;\n  text-align: center; }\n  @media screen and (min-width: 768px) {\n    .slide-module_question__1amzQ {\n      max-width: 640px; } }\n  .slide-module_question__1amzQ p {\n    margin-top: 0;\n    margin-bottom: 10px;\n    font-size: 22px;\n    font-weight: 700; }\n  .slide-module_question__1amzQ a {\n    margin-top: 0;\n    margin-bottom: 10px;\n    font-size: 22px;\n    font-weight: 700;\n    color: #333333;\n    border-bottom: 1px solid;\n    text-decoration: none;\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94); }\n    .slide-module_question__1amzQ a:hover {\n      color: #ffd326; }\n  .slide-module_question__1amzQ img {\n    display: inline-block !important;\n    width: 1em;\n    height: 1em;\n    margin-left: 0.25em;\n    margin-right: 0.25em; }\n    @media screen and (min-width: 768px) {\n      .slide-module_question__1amzQ img {\n        width: 1.5em;\n        height: 1.5em;\n        margin-bottom: -0.25em; } }\n  .slide-module_question__1amzQ iframe {\n    width: 100%;\n    height: 300px;\n    margin-top: 20px;\n    background-color: #d6f1ee;\n    border: none;\n    border-radius: 4px; }\n\n.slide-module_questionCenter__29eg5 {\n  margin-top: auto;\n  margin-bottom: auto; }\n\n.slide-module_answers__3Fgfv {\n  width: 100%;\n  margin-top: 40px;\n  display: flex;\n  flex-direction: column; }\n  @media screen and (min-width: 768px) {\n    .slide-module_answers__3Fgfv {\n      width: 600px;\n      margin-left: -10px;\n      margin-right: -10px;\n      flex-direction: row;\n      justify-content: center;\n      flex-wrap: wrap; } }\n\n.slide-module_answersWrap__3WbXf {\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: wrap; }\n  @media screen and (min-width: 768px) {\n    .slide-module_answersWrap__3WbXf {\n      justify-content: center; } }\n  .slide-module_answersWrap__3WbXf > button {\n    flex: 0 0 calc(50% - 10px); }\n    @media screen and (min-width: 768px) {\n      .slide-module_answersWrap__3WbXf > button {\n        flex: 0 0 calc(33.333% - 10px * 2); } }\n\n.slide-module_link__3tkK0 {\n  color: white;\n  border-bottom: 1px solid currentColor;\n  font-size: 14px;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94); }\n  .slide-module_link__3tkK0:hover {\n    color: #f4eed6; }\n\n.slide-module_linkDark__ar_do {\n  color: #79776b;\n  border-bottom: 1px solid #333333;\n  font-size: 14px;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94); }\n  .slide-module_linkDark__ar_do:hover {\n    color: #333333; }\n\n.slide-module_error__FUqfN {\n  display: inline-block;\n  margin-top: 30px;\n  padding: 10px 20px;\n  background-color: #d6f1ee;\n  border-radius: 0;\n  font-size: 14px;\n  color: #e8544c; }\n";
var styles$2 = {
  "container": "slide-module_container__3F2DY",
  "question": "slide-module_question__1amzQ",
  "questionCenter": "slide-module_questionCenter__29eg5 slide-module_question__1amzQ",
  "answers": "slide-module_answers__3Fgfv",
  "answersWrap": "slide-module_answersWrap__3WbXf slide-module_answers__3Fgfv",
  "link": "slide-module_link__3tkK0",
  "linkDark": "slide-module_linkDark__ar_do",
  "error": "slide-module_error__FUqfN"
};
styleInject(css_248z$5);
function Slide(_a) {
  var question = _a.question,
    error = _a.error,
    handleSubmit = _a.handleSubmit,
    handleViewRecommendations = _a.handleViewRecommendations,
    handleGoToLogin = _a.handleGoToLogin,
    handleGoToForgotPassword = _a.handleGoToForgotPassword,
    handleViewResultsClick = _a.handleViewResultsClick,
    handleCloseConsultation = _a.handleCloseConsultation,
    handleExitToVegan = _a.handleExitToVegan,
    handleExitToPregnant = _a.handleExitToPregnant,
    handleSignOut = _a.handleSignOut;
  var _b = React.useState([]),
    selectedAnswerIds = _b[0],
    setSelectedAnswerIds = _b[1];
  var _c = React.useState(false),
    isSubmit = _c[0],
    setIsSubmit = _c[1];
  var isMobile = typeof window !== 'undefined' && window && window.innerWidth <= 480;
  var maxItemsInRow = isMobile ? 5 : 3;
  var mockClickData = {
    type: '',
    action: 'autoSlide',
    id: ''
  };
  var dataContinueButton = {
    type: 'continue',
    action: 'button',
    id: '',
    label: 'Continue'
  };
  var renderMessages = function () {
    // check if the second message contains a "scrolling" url, and load it in a scrolling iframe
    var iframeRegex = RegExp(/^\[scrolling:(.)*$/);
    var hasIframe = question.messages[1] && iframeRegex.test(question.messages[1]);
    if (hasIframe) {
      var iframeUrlArr = question.messages[1].match(/\[scrolling:(.*?)\]/);
      var iframeUrl = iframeUrlArr[1];
      return React__default['default'].createElement(React__default['default'].Fragment, null, React__default['default'].createElement(ReactMarkdown__default['default'], {
        children: question.messages[0],
        rehypePlugins: [rehypeRaw__default['default']]
      }), React__default['default'].createElement("iframe", {
        src: iframeUrl
      }));
    } else {
      return React__default['default'].createElement(React__default['default'].Fragment, null, question.messages.map(function (message, index) {
        var linkRegex = RegExp(/^(.)*\[link:(.)*$/);
        var hasLink = linkRegex.test(message);
        var link = hasLink && message.split('link:')[1].slice(0, -1);
        var linkText = hasLink && message.split('[')[0];
        if (hasLink) {
          return React__default['default'].createElement("a", {
            href: link,
            target: "_blank"
          }, linkText);
        }
        return React__default['default'].createElement(ReactMarkdown__default['default'], {
          key: index,
          children: message,
          rehypePlugins: [rehypeRaw__default['default']]
        });
      }));
    }
  };
  var handleClick = function (answerData) {
    var answer = [answerData.id];
    var answerId;
    var answerValue;
    switch (answerData.action) {
      case 'autoSlide':
        setSelectedAnswerIds(['Auto']);
        setIsSubmit(true);
        break;
      case 'viewRecommendations':
        handleViewRecommendations();
        break;
      case 'viewResults':
      case 'generateAndViewResults':
        setSelectedAnswerIds(answer);
        setIsSubmit(true);
        handleViewResultsClick();
        break;
      case 'goToLogin':
        handleGoToLogin();
        break;
      case 'exit':
      case 'dismissScreen':
        handleCloseConsultation();
        break;
      case 'exitTo:vegan':
        handleCloseConsultation();
        handleExitToVegan();
        break;
      case 'exitTo:pregnant':
        handleCloseConsultation();
        handleExitToPregnant();
        break;
      case 'signOut':
        handleSignOut();
        break;
      default:
        switch (answerData.type) {
          case 'select':
            setIsSubmit(false);
            if (selectedAnswerIds.find(function (answerId) {
              return answerId === answerData.id;
            })) {
              setSelectedAnswerIds(__spreadArray([], selectedAnswerIds.filter(function (answerId) {
                return answerId !== answerData.id;
              })));
            } else {
              setSelectedAnswerIds(__spreadArray(__spreadArray([], selectedAnswerIds), answer));
            }
            break;
          case 'button':
            answer = [answerData.id || ''];
            setSelectedAnswerIds(answer);
            setIsSubmit(true);
            break;
          case 'email':
            answerId = [answerData.id || ''];
            answerValue = [answerData.value || ''];
            setSelectedAnswerIds([answerId + "textField" + answerValue]);
            setIsSubmit(true);
            break;
          case 'password':
            answerId = [answerData.id || ''];
            answerValue = [answerData.value || ''];
            setSelectedAnswerIds([answerId + "textField" + answerValue]);
            setIsSubmit(true);
            break;
          case 'text':
            answerId = [answerData.id || ''];
            answerValue = [answerData.value || ''];
            setSelectedAnswerIds([answerId + "textField" + answerValue]);
            setIsSubmit(true);
            break;
          case 'continue':
            if (selectedAnswerIds.length > 0) {
              setIsSubmit(true);
            }
            break;
        }
        break;
    }
  };
  var renderContinueButton = function () {
    var showContinueButton = question.answers.find(function (answer) {
      return answer.type === 'select';
    });
    return showContinueButton ? React__default['default'].createElement(Button, {
      data: dataContinueButton,
      selectedValues: selectedAnswerIds,
      handleClick: handleClick
    }) : null;
  };
  React.useEffect(function () {
    if (isSubmit) {
      handleSubmit(selectedAnswerIds);
    }
  }, [isSubmit, selectedAnswerIds]);
  React.useEffect(function () {
    if (question.autoSlide) {
      setTimeout(function () {
        handleClick(mockClickData);
      }, question.readTime);
    }
  }, [question]);
  return React__default['default'].createElement("div", {
    className: styles$2.container
  }, React__default['default'].createElement("div", {
    className: question.autoSlide ? styles$2.questionCenter : styles$2.question
  }, renderMessages()), React__default['default'].createElement("form", {
    autoComplete: "off",
    className: question.answers.length <= maxItemsInRow ? styles$2.answers : styles$2.answersWrap
  }, question.answers.map(function (answer, index) {
    return React__default['default'].createElement(React.Fragment, {
      key: answer.id
    }, function () {
      switch (answer.type) {
        case 'button':
          return React__default['default'].createElement(Button, {
            data: answer,
            selectedValues: selectedAnswerIds,
            handleClick: handleClick
          });
        case 'select':
          return React__default['default'].createElement(Button, {
            data: answer,
            selectedValues: selectedAnswerIds,
            handleClick: handleClick
          });
        case 'text':
          return React__default['default'].createElement(Input, {
            type: "text",
            data: answer,
            pattern: /^[a-zA-ZÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓ\s-\']+$/,
            handleClick: handleClick
          });
        case 'email':
          return React__default['default'].createElement(Input, {
            type: "email",
            data: answer,
            pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            handleClick: handleClick
          });
        case 'password':
          return React__default['default'].createElement(Input, {
            type: "password",
            data: answer,
            handleClick: handleClick
          });
        default:
          return null;
      }
    }());
  }), renderContinueButton()), question.answers.find(function (answer) {
    return answer.type === 'password';
  }) && React__default['default'].createElement("a", {
    className: styles$2.linkDark,
    onClick: handleGoToForgotPassword
  }, "Forgot password?"), error ? React__default['default'].createElement("p", {
    className: styles$2.error
  }, error) : null);
}
var css_248z$4 = ".overlay-module_container__1BAMD {\n  box-sizing: border-box;\n  line-height: 1.5;\n  font-family: \"sofia-pro\", sans-serif;\n  font-weight: 400;\n  color: #333333;\n  font-size: 18px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale; }\n  .overlay-module_container__1BAMD *,\n  .overlay-module_container__1BAMD *:before,\n  .overlay-module_container__1BAMD *:after {\n    box-sizing: inherit; }\n  .overlay-module_container__1BAMD h1,\n  .overlay-module_container__1BAMD h2,\n  .overlay-module_container__1BAMD h3,\n  .overlay-module_container__1BAMD h4,\n  .overlay-module_container__1BAMD h5,\n  .overlay-module_container__1BAMD h6 {\n    font-weight: 700;\n    font-family: inherit; }\n  .overlay-module_container__1BAMD img {\n    display: block; }\n  .overlay-module_container__1BAMD small {\n    font-size: 14px; }\n  .overlay-module_container__1BAMD ::placeholder {\n    font-family: \"sofia-pro\", sans-serif;\n    font-size: 18px;\n    color: #333333;\n    opacity: 1; }\n  .overlay-module_container__1BAMD :-ms-input-placeholder {\n    font-family: \"sofia-pro\", sans-serif;\n    font-size: 18px;\n    color: #333333;\n    opacity: 1; }\n  .overlay-module_container__1BAMD ::-ms-input-placeholder {\n    font-family: \"sofia-pro\", sans-serif;\n    font-size: 18px;\n    color: #333333;\n    opacity: 1; }\n\n.overlay-module_enter__19KUS {\n  opacity: 0;\n  transform: scale(0.9); }\n\n.overlay-module_enterActive__7702E {\n  opacity: 1;\n  transform: scale(1);\n  transition: all 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94); }\n\n.overlay-module_exit__1E2_8 {\n  opacity: 1;\n  transform: scale(1); }\n\n.overlay-module_exitActive__1umtB {\n  opacity: 0;\n  transform: scale(0.9);\n  transition: all 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94); }\n\n@keyframes overlay-module_fadeIn__2Zzt5 {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n\n.overlay-module_container__1BAMD {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  min-height: 100%;\n  background: #fff9e0;\n  font-family: \"sofia-pro\", sans-serif;\n  z-index: 100000;\n  display: flex;\n  flex-direction: column; }\n\n.overlay-module_header___VULK {\n  position: relative;\n  height: 70px;\n  padding: 20px;\n  display: flex;\n  align-items: center; }\n\n.overlay-module_content__x3EOS {\n  display: flex;\n  flex: 1; }\n  .overlay-module_content__x3EOS > div {\n    position: relative;\n    flex: 1; }\n    @media screen and (min-width: 768px) {\n      .overlay-module_content__x3EOS > div {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center; } }\n\n.overlay-module_logo__WU50j {\n  position: absolute;\n  left: 50%;\n  width: 60px;\n  height: auto;\n  transform: translateX(-50%); }\n\n.overlay-module_button__SyCst {\n  position: relative;\n  background: none;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  font-family: inherit;\n  color: #333333;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center; }\n  .overlay-module_button__SyCst:last-child {\n    margin-left: auto; }\n  .overlay-module_button__SyCst span {\n    position: absolute;\n    bottom: -20px; }\n\n.overlay-module_icon__3sFaW {\n  width: 20px;\n  height: auto; }\n\n.overlay-module_slide__2KzYH {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex; }\n\n.overlay-module_isLoading__2X0rP {\n  pointer-events: none; }\n";
var styles$1 = {
  "container": "overlay-module_container__1BAMD",
  "enter": "overlay-module_enter__19KUS",
  "enterActive": "overlay-module_enterActive__7702E",
  "exit": "overlay-module_exit__1E2_8",
  "exitActive": "overlay-module_exitActive__1umtB",
  "header": "overlay-module_header___VULK",
  "content": "overlay-module_content__x3EOS",
  "logo": "overlay-module_logo__WU50j",
  "button": "overlay-module_button__SyCst",
  "icon": "overlay-module_icon__3sFaW",
  "slide": "overlay-module_slide__2KzYH",
  "isLoading": "overlay-module_isLoading__2X0rP",
  "fadeIn": "overlay-module_fadeIn__2Zzt5"
};
styleInject(css_248z$4);
var css_248z$3 = ".slideLeft-module_enter__13TGf {\n  transform: translateX(100vw); }\n\n.slideLeft-module_enterActive__1gbqR {\n  transform: translateX(0);\n  transition: transform 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94); }\n  @media screen and (min-width: 768px) {\n    .slideLeft-module_enterActive__1gbqR {\n      transition-duration: 500ms; } }\n\n.slideLeft-module_exit__2vtPH {\n  transform: translateX(0); }\n\n.slideLeft-module_exitActive__1IOGn {\n  transform: translateX(-100vw);\n  transition: transform 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94); }\n  @media screen and (min-width: 768px) {\n    .slideLeft-module_exitActive__1IOGn {\n      transition-duration: 500ms; } }\n";
var slideLeftTransition = {
  "enter": "slideLeft-module_enter__13TGf",
  "enterActive": "slideLeft-module_enterActive__1gbqR",
  "exit": "slideLeft-module_exit__2vtPH",
  "exitActive": "slideLeft-module_exitActive__1IOGn"
};
styleInject(css_248z$3);
var css_248z$2 = ".slideRight-module_enter__2LZf3 {\n  transform: translateX(-100vw); }\n\n.slideRight-module_enterActive__d-5ty {\n  transform: translateX(0);\n  transition: transform 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94); }\n  @media screen and (min-width: 768px) {\n    .slideRight-module_enterActive__d-5ty {\n      transition-duration: 500ms; } }\n\n.slideRight-module_exit__3BYKG {\n  transform: translateX(0); }\n\n.slideRight-module_exitActive__3FzWJ {\n  transform: translateX(100vw);\n  transition: transform 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94); }\n  @media screen and (min-width: 768px) {\n    .slideRight-module_exitActive__3FzWJ {\n      transition-duration: 500ms; } }\n";
var slideRightTransition = {
  "enter": "slideRight-module_enter__2LZf3",
  "enterActive": "slideRight-module_enterActive__d-5ty",
  "exit": "slideRight-module_exit__3BYKG",
  "exitActive": "slideRight-module_exitActive__3FzWJ"
};
styleInject(css_248z$2);
var DELIVERY_ADDRESS_FRAGMENT = client$1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment deliveryAddressFields on DeliveryAddress {\n    id\n    title\n    firstName\n    lastName\n    address\n    town\n    county\n    postcode\n    country\n    summary\n    default\n  }\n"], ["\n  fragment deliveryAddressFields on DeliveryAddress {\n    id\n    title\n    firstName\n    lastName\n    address\n    town\n    county\n    postcode\n    country\n    summary\n    default\n  }\n"])));
var PAYMENT_METHOD_FRAGMENT = client$1.gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  fragment paymentMethodFields on PaymentMethod {\n    id\n    type\n    description\n    cardIssuer\n    icon {\n      url\n    }\n    lastFourDigits\n    expMonth\n    expYear\n    name\n    postcode\n    default\n  }\n"], ["\n  fragment paymentMethodFields on PaymentMethod {\n    id\n    type\n    description\n    cardIssuer\n    icon {\n      url\n    }\n    lastFourDigits\n    expMonth\n    expYear\n    name\n    postcode\n    default\n  }\n"])));
var USER_FRAGMENT = client$1.gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  fragment userFields on User {\n    id\n    segment_id\n    email\n    emailHashed\n    type\n    firstName\n    firstNamePlural\n    referralCode\n    deliveryAddresses {\n      ...deliveryAddressFields\n    }\n    paymentMethods {\n      ...paymentMethodFields\n    }\n  }\n  ", "\n  ", "\n"], ["\n  fragment userFields on User {\n    id\n    segment_id\n    email\n    emailHashed\n    type\n    firstName\n    firstNamePlural\n    referralCode\n    deliveryAddresses {\n      ...deliveryAddressFields\n    }\n    paymentMethods {\n      ...paymentMethodFields\n    }\n  }\n  ", "\n  ", "\n"])), DELIVERY_ADDRESS_FRAGMENT, PAYMENT_METHOD_FRAGMENT);
var QUESTION_FRAGMENT = client$1.gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  fragment questionFields on Question {\n    id\n    messages\n    answers {\n      id\n      label\n      type\n      action\n      image\n    }\n  }\n"], ["\n  fragment questionFields on Question {\n    id\n    messages\n    answers {\n      id\n      label\n      type\n      action\n      image\n    }\n  }\n"])));
var CHAT_FRAGMENT = client$1.gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  fragment chatFields on ChatMessage {\n    token\n    canGoBack\n    question {\n      ...questionFields\n    }\n  }\n  ", "\n"], ["\n  fragment chatFields on ChatMessage {\n    token\n    canGoBack\n    question {\n      ...questionFields\n    }\n  }\n  ", "\n"])), QUESTION_FRAGMENT);
client$1.gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  query user {\n    user {\n      ...userFields\n    }\n  }\n  ", "\n"], ["\n  query user {\n    user {\n      ...userFields\n    }\n  }\n  ", "\n"])), USER_FRAGMENT);
// export const REGISTER_LEAD = gql`
//     mutation RegisterLead($signupPage: String, $email: String, $leadAttribution: [KeyValueInput]) {
//         user_createLead(data: { signup_page: $signupPage, email: $email }, leadAttribution: $leadAttribution) {
//             ...userFields
//         }
//     }
//     ${USER_FRAGMENT}
// `;
client$1.gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  mutation guest_create {\n    guest_create\n  }\n"], ["\n  mutation guest_create {\n    guest_create\n  }\n"])));
var GET_CHAT = client$1.gql(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  query chat_load($variant: String!) {\n    chat_load(variant: $variant) {\n      ...chatFields\n    }\n  }\n  ", "\n"], ["\n  query chat_load($variant: String!) {\n    chat_load(variant: $variant) {\n      ...chatFields\n    }\n  }\n  ", "\n"])), CHAT_FRAGMENT);
var SEND_RESPONSE = client$1.gql(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  mutation chat_sendResponse(\n    $variant: String!\n    $questionId: ID!\n    $responses: [ChatResponse]\n  ) {\n    chat_sendResponse(\n      variant: $variant\n      questionId: $questionId\n      responses: $responses\n    ) {\n      ...chatFields\n    }\n  }\n  ", "\n"], ["\n  mutation chat_sendResponse(\n    $variant: String!\n    $questionId: ID!\n    $responses: [ChatResponse]\n  ) {\n    chat_sendResponse(\n      variant: $variant\n      questionId: $questionId\n      responses: $responses\n    ) {\n      ...chatFields\n    }\n  }\n  ", "\n"])), CHAT_FRAGMENT);
var UNDO_PREVIOUS_RESPONSE = client$1.gql(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  mutation chat_undoPreviousResponse($variant: String!) {\n    chat_undoPreviousResponse(variant: $variant) {\n      ...chatFields\n    }\n  }\n  ", "\n"], ["\n  mutation chat_undoPreviousResponse($variant: String!) {\n    chat_undoPreviousResponse(variant: $variant) {\n      ...chatFields\n    }\n  }\n  ", "\n"])), CHAT_FRAGMENT);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;
var parseQuestion = function (question) {
  question.messages = question.messages.map(function (message) {
    return parseEmoji(message);
  });
  if (question.answers) {
    question.answers = question.answers.map(function (answer) {
      var image = parseEmoji(answer.image || '');
      var label = parseText(answer.label);
      return __assign(__assign({}, answer), {
        image: image,
        label: label
      });
    });
  }
  return question;
};
// custom emoji replacement
var parseEmoji = function (text) {
  // @ts-ignore
  return twemoji__default['default'].parse(text, function (icon) {
    return "https://static.vitl.com/assets/emojis/u" + icon.toUpperCase() + ".png";
  });
};
var parseText = function (text) {
  var textLines = text.split('\n');
  return textLines.reduce(function (acc, curr) {
    return acc + ("<span>" + curr + "</span>");
  }, "");
};
var formatError = function (errorMessage) {
  return errorMessage.toString().replace('GraphQL error: ', '');
};
function OverlayComponent(props) {
  // state
  var _a = React.useState([]),
    questions = _a[0],
    setQuestions = _a[1];
  var _b = React.useState(''),
    activeQuestionID = _b[0],
    setActiveQuestionID = _b[1];
  var _c = React.useState(''),
    storedEmail = _c[0],
    setStoredEmail = _c[1];
  var _d = React.useState(slideLeftTransition),
    transitionClass = _d[0],
    setTransitionClass = _d[1];
  var _e = React.useState(false),
    showBackBtn = _e[0],
    setShowBackBtn = _e[1];
  var _f = React.useState(false),
    isViewResultsSelected = _f[0],
    setIsViewResultsSelected = _f[1];
  var _g = React.useState(false),
    isLoading = _g[0],
    setIsLoading = _g[1];
  var _h = React.useState(''),
    error = _h[0],
    setError = _h[1];
  var _j = React.useState(false),
    isUserIdentified = _j[0],
    setIsUserIdentified = _j[1];
  var _k = client$1.useLazyQuery(GET_CHAT, {
      variables: {
        variant: props.chatVariant
      },
      fetchPolicy: 'network-only'
    }),
    getChatData = _k[0],
    chatData = _k[1].data;
  React.useEffect(function () {
    getChatData();
  }, [getChatData]);
  // on init
  React.useEffect(function () {
    if (!chatData) {
      return;
    }
    var question = JSON.parse(JSON.stringify(chatData.chat_load.question));
    checkAutoSlide(question);
    question = parseQuestion(question);
    setQuestions([question]);
    setActiveQuestionID(chatData.chat_load.question.id);
    setShowBackBtn(chatData.chat_load.canGoBack);
  }, [chatData]);
  var getNextQuestion = client$1.useMutation(SEND_RESPONSE, {
    onCompleted: function (data) {
      var currentQuestion = questions.pop();
      var nextQuestion = data.chat_sendResponse.question;
      var chatSendResponseToken = data.chat_sendResponse.token;
      if (chatSendResponseToken && !isUserIdentified) {
        props.handleSetToken(data.chat_sendResponse.token);
        // tracking
        props.handleIdentifyUser();
        setIsUserIdentified(true);
      }
      if (isViewResultsSelected) {
        props.handleViewResults();
        setIsLoading(false);
        setError('');
        return;
      }
      checkAutoSlide(nextQuestion);
      parseQuestion(nextQuestion);
      setQuestions([currentQuestion, nextQuestion]);
      setActiveQuestionID(nextQuestion.id);
      setShowBackBtn(data.chat_sendResponse.canGoBack);
      setIsLoading(false);
      setError('');
    },
    onError: function (error) {
      if (isViewResultsSelected) {
        props.handleViewResults();
      }
      (error === null || error === void 0 ? void 0 : error.message) ? setError(formatError(error.message)) : setError('Something went wrong. Please try again.');
    }
  })[0];
  var getPrevQuestion = client$1.useMutation(UNDO_PREVIOUS_RESPONSE, {
    onCompleted: function (data) {
      var previousQuestion = data.chat_undoPreviousResponse.question;
      var currentQuestion = previousQuestion.id === questions[0].id ? questions[questions.length - 1] : questions[0];
      checkAutoSlide(previousQuestion);
      parseQuestion(previousQuestion);
      setQuestions([previousQuestion, currentQuestion]);
      setActiveQuestionID(previousQuestion.id);
      setShowBackBtn(data.chat_undoPreviousResponse.canGoBack);
      setIsLoading(false);
      setError('');
    },
    onError: function (error) {
      setError(error.toString().replace('Error: GraphQL error: ', ''));
    }
  })[0];
  // dynamic enter/leave animations for the slides. https://medium.com/lalilo/dynamic-transitions-with-react-router-and-react-transition-group-69ab795815c9
  var dynamicChildFactory = function (classNames) {
    return function (child) {
      return React__default['default'].cloneElement(child, {
        classNames: classNames
      });
    };
  };
  var handleSubmit = function (data) {
    var chatResponses = [];
    if (data[0].includes('textField')) {
      var dataArray = data[0].split('textField');
      chatResponses.push({
        identifier: dataArray[0],
        value: dataArray[1]
      });
    } else {
      data.forEach(function (dataItem) {
        return chatResponses.push({
          identifier: dataItem,
          value: ''
        });
      });
    }
    if (activeQuestionID === 'SignIn-Email' || activeQuestionID === 'Register-Email') {
      setStoredEmail(data[0]);
      chatResponses.push({
        identifier: activeQuestionID,
        value: storedEmail
      });
    }
    if (activeQuestionID === 'SignIn-Password' || activeQuestionID === 'AlreadyRegistered') {
      chatResponses.push({
        identifier: activeQuestionID,
        value: storedEmail
      });
    }
    setIsLoading(true);
    setTransitionClass(slideLeftTransition);
    // slide to next question
    getNextQuestion({
      variables: {
        variant: props.chatVariant,
        questionId: activeQuestionID,
        responses: chatResponses
      }
    });
  };
  var handleGoBack = function () {
    setIsLoading(true);
    setTransitionClass(slideRightTransition);
    // slide to previous question
    getPrevQuestion({
      variables: {
        variant: props.chatVariant,
        questionid: activeQuestionID
      }
    });
  };
  var checkAutoSlide = function (question) {
    // check if question should auto slide
    question.autoSlide = question.answers.length === 0;
    if (question.autoSlide) {
      // user reading time before auto slide to next one
      var chars = question.messages[0].length;
      question.readTime = 1100 + chars * 45;
    }
  };
  var handleViewResultsClick = function () {
    setIsViewResultsSelected(true);
  };
  return React__default['default'].createElement("div", {
    className: styles$1.container
  }, React__default['default'].createElement("div", {
    className: styles$1.header
  }, React__default['default'].createElement("img", {
    className: styles$1.logo,
    src: 'https://static.vitl.com/images/logo/vitl_logo.svg',
    alt: 'vitl'
  }), showBackBtn && React__default['default'].createElement("button", {
    type: 'button',
    className: styles$1.button + " " + (isLoading && !error ? styles$1.isLoading : ''),
    onClick: function () {
      return handleGoBack();
    }
  }, React__default['default'].createElement("img", {
    className: styles$1.icon,
    src: 'https://static.vitl.com/images/icons/reload.svg',
    alt: ''
  }), React__default['default'].createElement("span", null, "Back")), React__default['default'].createElement("button", {
    type: 'button',
    className: styles$1.button,
    onClick: function () {
      return props.handleCloseConsultation();
    }
  }, React__default['default'].createElement("img", {
    className: styles$1.icon,
    src: 'https://static.vitl.com/images/icons/cross.svg',
    alt: ''
  }))), questions ? React__default['default'].createElement("div", {
    className: styles$1.content + " " + (isLoading && !error ? styles$1.isLoading : '')
  }, React__default['default'].createElement(reactTransitionGroup.TransitionGroup, {
    childFactory: dynamicChildFactory(transitionClass)
  }, questions.map(function (question) {
    return question.id === activeQuestionID && React__default['default'].createElement(reactTransitionGroup.CSSTransition, {
      classNames: transitionClass,
      timeout: SLIDE_ANIMATION_DURATION,
      key: question.id
    }, React__default['default'].createElement(Slide, {
      question: question,
      error: error,
      handleSubmit: handleSubmit,
      handleViewRecommendations: props.handleViewRecommendations,
      handleViewResultsClick: handleViewResultsClick,
      handleGoToLogin: props.handleGoToLogin,
      handleGoToForgotPassword: props.handleGoToForgotPassword,
      handleExitToVegan: props.handleExitToVegan,
      handleExitToPregnant: props.handleExitToPregnant,
      handleCloseConsultation: props.handleCloseConsultation,
      handleSignOut: props.handleSignOut
    }));
  }))) : null);
}
var css_248z$1 = ".index-module_bodyFixed__19POX {\n  position: fixed;\n  width: 100%; }\n";
var styles = {
  "bodyFixed": "index-module_bodyFixed__19POX"
};
styleInject(css_248z$1);
var css_248z = ".fade-module_enter__1lfoD {\n  opacity: 0;\n  transform: scale(0.9); }\n\n.fade-module_enterActive__3L94- {\n  opacity: 1;\n  transform: scale(1);\n  transition: all 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94); }\n\n.fade-module_exit__2-8ON {\n  opacity: 1;\n  transform: scale(1); }\n\n.fade-module_exitActive__27FXM {\n  opacity: 0;\n  transform: scale(0.9);\n  transition: all 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94); }\n\n@keyframes fade-module_fadeIn__2M3s9 {\n  0% {\n    opacity: 0; }\n  100% {\n    opacity: 1; } }\n";
var fadeTransition = {
  "enter": "fade-module_enter__1lfoD",
  "enterActive": "fade-module_enterActive__3L94-",
  "exit": "fade-module_exit__2-8ON",
  "exitActive": "fade-module_exitActive__27FXM",
  "fadeIn": "fade-module_fadeIn__2M3s9"
};
styleInject(css_248z);
var VitlConsultation = function (_a) {
  var apiUrl = _a.apiUrl,
    apiKey = _a.apiKey,
    _b = _a.viewResultsCallback,
    viewResultsCallback = _b === void 0 ? function () {} : _b,
    _c = _a.viewRecommendationsCallback,
    viewRecommendationsCallback = _c === void 0 ? function () {} : _c,
    _d = _a.identifyUserCallback,
    identifyUserCallback = _d === void 0 ? function () {} : _d,
    _e = _a.goToLoginCallback,
    goToLoginCallback = _e === void 0 ? function () {} : _e,
    _f = _a.goToForgotPasswordCallback,
    goToForgotPasswordCallback = _f === void 0 ? function () {} : _f,
    _g = _a.exitToVeganCallback,
    exitToVeganCallback = _g === void 0 ? function () {} : _g,
    _h = _a.exitToPregnantCallback,
    exitToPregnantCallback = _h === void 0 ? function () {} : _h,
    _j = _a.closeConsultationCallback,
    closeConsultationCallback = _j === void 0 ? function () {} : _j,
    isOverlayOpen = _a.isOverlayOpen,
    _k = _a.deleteUserDataCallback,
    deleteUserDataCallback = _k === void 0 ? function () {} : _k,
    _l = _a.getTokenCallback,
    getTokenCallback = _l === void 0 ? function () {
      return '';
    } : _l,
    _m = _a.getGuestTokenCallback,
    getGuestTokenCallback = _m === void 0 ? function () {
      return '';
    } : _m,
    _o = _a.setTokenCallback,
    setTokenCallback = _o === void 0 ? function () {} : _o,
    _p = _a.onErrorCallback,
    onErrorCallback = _p === void 0 ? function () {} : _p;
  React.useEffect(function () {
    return function () {
      document.body.classList.remove(styles.bodyFixed);
    };
  }, []);
  var token = getTokenCallback() || getGuestTokenCallback();
  if (isOverlayOpen && token) {
    document.body.classList.add(styles.bodyFixed);
  }
  return React__default['default'].createElement(client$1.ApolloProvider, {
    client: client({
      apiUrl: apiUrl,
      apiKey: apiKey,
      getTokenCallback: getTokenCallback,
      getGuestTokenCallback: getGuestTokenCallback,
      onErrorCallback: onErrorCallback
    })
  }, React__default['default'].createElement(reactTransitionGroup.CSSTransition, {
    in: token !== '' && isOverlayOpen,
    classNames: fadeTransition,
    timeout: 200,
    unmountOnExit: true
  }, React__default['default'].createElement(OverlayComponent, {
    chatVariant: CHAT_VARIANT,
    handleViewResults: viewResultsCallback,
    handleViewRecommendations: viewRecommendationsCallback,
    handleIdentifyUser: identifyUserCallback,
    handleGoToLogin: goToLoginCallback,
    handleGoToForgotPassword: goToForgotPasswordCallback,
    handleExitToVegan: exitToVeganCallback,
    handleExitToPregnant: exitToPregnantCallback,
    handleCloseConsultation: closeConsultationCallback,
    handleSignOut: deleteUserDataCallback,
    handleSetToken: setTokenCallback
  })));
};
exports.VitlConsultation = VitlConsultation;